import { DeviceDTO } from '@eppendorf/vnls-device-service-utils';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { DeviceNameCell } from '$components/device/name-cell';
import { InfoList } from '$features/devices/device-information/info-list';

export function NotificationDevicesInfo({
  devices,
  fetchError,
}: {
  devices: DeviceDTO[] | null;
  fetchError: boolean;
}): ReactElement {
  const { t } = useTranslation();
  const noDevices = devices?.length === 0;

  return (
    <InfoList>
      <InfoList.Title>{t('notificationDetail.devices')}</InfoList.Title>
      <div className="m-top-l">
        {devices &&
          devices.map((device, index) => (
            <div
              key={device.serialNumber}
              className={
                index === devices.length - 1
                  ? 'flex flex__ai--center'
                  : 'flex flex__ai--center p-bottom-m'
              }
            >
              <DeviceNameCell device={device} />
            </div>
          ))}
        {fetchError && !noDevices && (
          <p className="color-red-500">
            {t('notificationDetail.errorLoadingDevices')}{' '}
            {t(`notificationDetail.tryAgain`)}
          </p>
        )}
        {noDevices && (
          <p className="color-red-500">
            {t('notificationDetail.noDevicesFound')} {t(`notificationDetail.tryAgain`)}
          </p>
        )}
      </div>
    </InfoList>
  );
}
